import type { ChainModifiers, Entry, EntryFieldTypes, EntrySkeletonType, LocaleCode } from 'contentful'

export interface TypeMathseedsPrimeLessonResourceFields {
  title: EntryFieldTypes.Symbol
  resourceType: EntryFieldTypes.Symbol<'problem_solving' | 'skills' | 'student_pdf' | 'teacher_pdf'>
  cover: EntryFieldTypes.AssetLink
  file: EntryFieldTypes.AssetLink
}

export type TypeMathseedsPrimeLessonResourceSkeleton = EntrySkeletonType<
  TypeMathseedsPrimeLessonResourceFields,
  'mathseedsPrimeLessonResource'
>
export type TypeMathseedsPrimeLessonResource<
  Modifiers extends ChainModifiers,
  Locales extends LocaleCode = LocaleCode,
> = Entry<TypeMathseedsPrimeLessonResourceSkeleton, Modifiers, Locales>

export function isTypeMathseedsPrimeLessonResource<Modifiers extends ChainModifiers, Locales extends LocaleCode>(
  entry: Entry<EntrySkeletonType, Modifiers, Locales>,
): entry is TypeMathseedsPrimeLessonResource<Modifiers, Locales> {
  return entry.sys.contentType.sys.id === 'mathseedsPrimeLessonResource'
}

export type TypeMathseedsPrimeLessonResourceWithoutLinkResolutionResponse =
  TypeMathseedsPrimeLessonResource<'WITHOUT_LINK_RESOLUTION'>
export type TypeMathseedsPrimeLessonResourceWithoutUnresolvableLinksResponse =
  TypeMathseedsPrimeLessonResource<'WITHOUT_UNRESOLVABLE_LINKS'>
export type TypeMathseedsPrimeLessonResourceWithAllLocalesResponse<Locales extends LocaleCode = LocaleCode> =
  TypeMathseedsPrimeLessonResource<'WITH_ALL_LOCALES', Locales>
export type TypeMathseedsPrimeLessonResourceWithAllLocalesAndWithoutLinkResolutionResponse<
  Locales extends LocaleCode = LocaleCode,
> = TypeMathseedsPrimeLessonResource<'WITHOUT_LINK_RESOLUTION' | 'WITH_ALL_LOCALES', Locales>
export type TypeMathseedsPrimeLessonResourceWithAllLocalesAndWithoutUnresolvableLinksResponse<
  Locales extends LocaleCode = LocaleCode,
> = TypeMathseedsPrimeLessonResource<'WITHOUT_UNRESOLVABLE_LINKS' | 'WITH_ALL_LOCALES', Locales>
